import Vue from 'vue';
import orderTransformer from './../../transformers/order';
import store from './../../store';

const success = ({ data }, resolve) => {
  store.dispatch('fetchCurrentOrder', orderTransformer.fetch(data));
  resolve(orderTransformer.fetch(data));
};

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/orders/simple-order/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/order/simpleOrder.js